import * as RadixTabs from '@radix-ui/react-tabs';

export type TabItem = {
  value: string;
  label: string;
  count?: number;
};

type Props = {
  items: TabItem[];
  value: string;
  onChange: (value: string) => void;
  children?: React.ReactNode;
};

export function Tabs({ items, value, onChange, children }: Props) {
  return (
    <RadixTabs.Root value={value} onValueChange={onChange}>
      <RadixTabs.List
        aria-label="Filters"
        style={{
          display: 'flex',
          gap: 0,
          borderBottom: '1px solid var(--border-default)',
          marginBottom: 20,
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
        }}
      >
        {items.map((item) => (
          <RadixTabs.Trigger
            key={item.value}
            value={item.value}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '8px 16px',
              fontSize: 'var(--text-sm)',
              fontFamily: 'var(--font-body)',
              fontWeight: 500,
              color: 'var(--text-tertiary)',
              background: 'transparent',
              border: 'none',
              borderBottom: '2px solid transparent',
              cursor: 'pointer',
              transition: 'color var(--transition-fast), border-color var(--transition-fast)',
              marginBottom: -1,
              outline: 'none',
            }}
            data-active={value === item.value}
            onMouseEnter={(e) => {
              if (value !== item.value) (e.currentTarget as HTMLElement).style.color = 'var(--text-secondary)';
            }}
            onMouseLeave={(e) => {
              if (value !== item.value) (e.currentTarget as HTMLElement).style.color = 'var(--text-tertiary)';
            }}
          >
            <style>{`
              [data-state="active"][data-radix-collection-item] {
                color: var(--text-brand) !important;
                border-bottom-color: var(--brand-primary) !important;
              }
            `}</style>
            {item.label}
            {item.count !== undefined && (
              <span
                style={{
                  fontSize: 'var(--text-xs)',
                  fontWeight: 600,
                  padding: '1px 6px',
                  borderRadius: 'var(--radius-full)',
                  background: value === item.value ? 'var(--brand-muted)' : 'var(--warm-gray-100)',
                  color: value === item.value ? 'var(--text-brand)' : 'var(--text-tertiary)',
                  transition: 'background var(--transition-fast), color var(--transition-fast)',
                }}
              >
                {item.count}
              </span>
            )}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {children}
    </RadixTabs.Root>
  );
}

export const TabContent = RadixTabs.Content;
